import React from "react";
import { Routes, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReportWizard from "../ReportWizard/ReportWizard";
import Header from "../../components/Header/Header";
import Loader from "../../components/Loader/Loader";
import SignOut from "../../components/SignOut/SignOut";
import SignIn from "../../components/SignIn/SignIn";
import PrivateRoute from "../../components/PrivateRoute";
import "./App.scss";


const App = () => {
  const renderHeader = () => {
    const isSignedIn =
      localStorage.getItem("amplify-redirected-from-hosted-ui") === "true" ||
      localStorage.getItem('amplify-signin-with-hostedUI') === 'true'
      return isSignedIn ? (
      <div className="exclude-print">
        <Header />
      </div>
    ) : (
      <Loader />
    );
  };
  return (
    <div className="app-cls">
      {renderHeader()}
      <Routes>
        <Route path="/signIn" element={<SignIn />} />
        <Route path="/signout" element={<SignOut />} />
        <Route element={<PrivateRoute />}>
          <Route path="/*" element={<ReportWizard />} />
        </Route>
      </Routes>
    </div>
  );
};

export default App;

App.propTypes = {
  authState: PropTypes.string
}
